// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","cardFeed":"_2X9etpmYAfrrMCKYRQF9aj","secondary":"_3zyaZz-H2MKpcX7t-tpxWv"};